import { View } from '@gaming/srvg-classes-core';
import { GroupResultWidget } from "../../widgets/View/VfWidget/GroupResultWidget";
import { LivetableWidget } from "../../widgets/View/VfWidget/LivetableWidget";

export class GroupTablesView extends View {
    groupResultWidget: GroupResultWidget;
    livetableWidget: LivetableWidget;
    groupNr:number;

    constructor( options ) {
        options = options || {};
        options.name = options.name || 'groupTablesView';
        super( options );
        this.groupNr = options.groupNr || 0;
        this.groupResultWidget = null;
        this.livetableWidget = null;
    }

    handleDomInstantiated() {
        if (srvg.widgets.widgets['groupresult'].enabled) {
            this.groupResultWidget = this.addSubView(new GroupResultWidget({
                selector: this.selector + ' .GroupResultsWidget',
                // mapping rounds to group names, we get numbers but widget need 'A' till 'F'
                group: srvg.mapping.rounds[this.groupNr],
                // use platform constant for overlay_small
                platform: 'overlay-small',
                // show group name
                showGroupHeader: true,
                // mark group if currently playing
                showActiveGroupBorder: false,
                // deactivate automatic updates
                subscribeToLiveScoreMatch: false,
                widgetGroup: srvg.widgets.widget_group || ''
            }));
        }

        if (srvg.widgets.widgets['livetable'].enabled) {
            this.livetableWidget = this.addSubView(new LivetableWidget({
                selector: this.selector + ' .LiveGroupTableWidget',
                group: srvg.mapping.rounds[this.groupNr],
                diff: false,
                platform: 'overlay-small',
                // show group name
                showGroupHeader: false,
                form: srvg.widgets.overlaySettings.form,
                // mark group if currently playing
                showActiveGroupBorder: false,
                widgetGroup: srvg.widgets.widget_group || ''
            }));
        }
        super.handleDomInstantiated();
    }
}